import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-300px w-md-300px justify-content-center",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5 row" }
const _hoisted_6 = { class: "mb-10 col-8" }
const _hoisted_7 = { class: "form-label fw-bold" }
const _hoisted_8 = { class: "d-flex justify-content-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("filters")), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("dates")), 1),
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterDate) = $event)),
          locale: "es",
          minDate: _ctx.minDate,
          maxDate: 
            _ctx.maxDate == null
              ? new Date()
              : _ctx.maxDate < new Date()
              ? _ctx.maxDate
              : new Date()
          ,
          maxRange: 3,
          enableTimePicker: false,
          startTime: [
            { hours: 0, minutes: 0, seconds: 0 },
            { hours: 23, minutes: 59, seconds: 59 },
          ],
          range: "",
          inline: "",
          autoApply: "",
          autoRange: 4
        }, null, 8, ["modelValue", "minDate", "maxDate"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          disabled: _ctx.filterDate.length == 0 && _ctx.haveFilter == false
        }, _toDisplayString(_ctx.$t("deleteFilters")), 9, _hoisted_9),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true",
          disabled: 
            _ctx.filterDate.length == 0 ||
            (_ctx.actualDate == _ctx.filterDate && _ctx.filterDate != [])
          ,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFilters && _ctx.setFilters(...args)))
        }, _toDisplayString(_ctx.$t("apply")), 9, _hoisted_10)
      ])
    ])
  ]))
}